<template>
  <div class="total">
      <div class="progress" :style="{ right: percent + '%' }"></div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: [ 'total', 'value', 'speed' ],
  data: function () {
    return {
      clientValue: this.value
    }
  },
  mounted: function () {
    var tickTime = 100
    this.tick = setInterval(() => {
      this.clientValue -= this.speed * tickTime / 1000
    }, tickTime)
  },
  computed: {
    percent: {
      get () {
        return this.clientValue * 100 / this.total
      }
    }
  },
  watch: {
    value: function () {
      this.clientValue = this.value
    }
  }
}
</script>

<style scoped>
.total {
    /*
    border: 1px solid #5fb15f;
    padding: 1px;
    border-radius: 4px;
    */
}
.progress {
    /*
    background-color: #5fb15f;
    height: 6px;
    border-radius: 2px;
    */

    background-color: #66ca69;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0%;
    z-index: -100;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/ProgressBar.vue